<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-row
            class="flex-child"
        >
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-container fluid>
                        <v-row align="center">
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.showRecords.studentName')"
                                    v-model="searchData.stuName"
                                />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.showRecords.appraiseName')"
                                    v-model="searchData.criticsName"
                                />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.showRecords.examName')"
                                    v-model="searchData.examName"
                                />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-select
                                    @change="pageChange"
                                    :items="userTypeItems"
                                    :label="$vuetify.lang.t('$vuetify.custom.showRecords.commentType')"
                                    hide-details
                                    solo
                                    v-model="searchData.recordType"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <ETDatePicker v-model="searchData.appraiseTime"
                                              :label="$vuetify.lang.t('$vuetify.custom.showRecords.appraiseTime')"></ETDatePicker>
                            </v-col>
                            <v-col cols="12" md="9" sm="3" xs="3">
                                <v-row justify="end">
                                    <v-btn color="primary mr-3" @click="pageChange" dark large>
                                        <v-icon left>mdi-magnify</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}
                                    </v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="desserts"
                        item-key="name"
                        class="elevation-1"
                        multi-sort
                        :loading="loading"
                        :footer-props="footerProps"
                        :loading-text="loadingText"
                        :options.sync="options"
                        :server-items-length="totalDesserts"
                        @update:options="changeOptions"
                    >
                        <template v-slot:item.recordType="{ item }">
                            {{ item.recordType?'跟踪记录':'老师评价' }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn color="normal" x-small @click="showDetailDialog(item)" class="ml-2">
                                <v-icon small>
                                    mdi-account-details
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.detail') }}
                            </v-btn>
                            <v-btn :disabled="itemDisabled(item)" class="ml-2" :color="isEnable(item).color"
                                   x-small @click="read(item)">
                                <v-icon small>
                                    {{isEnable(item).icon}}
                                </v-icon>
                                {{isEnable(item).text}}
                            </v-btn>
                            <v-btn color="normal" x-small class="ml-2" @click="watchPic(item)" v-if="item.fileIds.length > 0">
                                <v-icon small>
                                    mdi-picture-in-picture-top-right
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.showRecords.watchPic') }}
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>
        </v-row>
        <v-dialog v-model="showDetail" max-width="1000px">
            <score-detail v-model="showDetail" :stuDetailMsg="stuDetailMsg"></score-detail>
        </v-dialog>
        <v-dialog v-model="showPic" max-width="1500px">
            <img ref="imgRef" v-show="true" :src="filePath" :preview="fileDesc" :preview-text="fileDesc">
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<script>
import scoreDetail from '../score/score-detail'
import ETDatePicker from '@/components/datepicker/ETDatePicker'
    export default {
        data() {
            return {
                overlay:false,
                showPic:false,
                filePath:'',
                fileDesc:'',
                fileId:'',
                permissionCode:{
                },
                userTypeItems:[
                    {text: "选择类型", value: ''},
                    {text: '跟踪记录', value: 1},
                    {text: '老师评价', value: 0},
                ],
                stuDetailMsg:{},
                showDetail:false,
                loading: true,
                loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
                selected: [],
                footerProps: {
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions:[5,10,20,50],
                    //disableItemsPerPage:true,
                },
                searchData: {
                    stuName: '',
                    criticsName: '',
                    examName: '',
                    recordType: '',
                    appraiseTime: [],
                    startDate: '',
                    endDate: '',
                },
                options: {},
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showRecords.studentName'), value: 'stuName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showRecords.appraiseName'), value: 'username',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showRecords.examName'), value: 'examName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showRecords.comment'), value: 'comment',width:300,
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showRecords.commentType'), value: 'recordType',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.showRecords.appraiseTime'), value: 'createTime',
                    },
                    {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
                ],
                totalDesserts: 0,
                desserts: [],
            }

        },
        watch:{
            'searchData.appraiseTime'(){
                this.initialize()
            },
            fileId() {
                if (this.fileId) {
                    let _this = this
                    this.filePath = this.$file.fileDownload(this.fileId)
                    setTimeout(function () {
                        _this.showPic = true
                        // _this.$refs.imgRef.click()
                    }, 200)
                }
            },
        },
        methods: {
            watchPic(item) {
                this.fileId = ''
                this.fileDesc = ''
                setTimeout(() => {
                    this.$api.studentRecords.lookPic(item.id).then(data => {
                        if (data.data && data.data.length > 0) {
                            this.fileId = data.data[0].fileId
                            this.fileDesc = item.comment
                        } else {
                            this.$dialog.alert("暂无图片展示")
                        }
                    })
                },100)
            },
            itemDisabled(item){
                if(item.status)
                    return true
                else
                    return false
            },
            read(item) {
                this.overlay = true
                this.$api.studentRecords.haveRead({
                    recordId:item.id
                }).then(data => {
                    if (data.flag) {
                        this.initialize()
                    }
                    this.overlay = false
                })
            },
            isEnable(item) {
                let icon = 'mdi-check-circle';
                let color = 'success';
                let text = this.$vuetify.lang.t('$vuetify.custom.showRecords.read')
                if (!item.status) {
                    icon = 'mdi-close-circle';
                    color = 'error';
                    text = this.$vuetify.lang.t('$vuetify.custom.showRecords.notRead')
                }
                return {
                    icon: icon,
                    color: color,
                    text: text
                }
            },
            //用户详细弹窗
            showDetailDialog(item) {
                this.showDetail = true;
                this.stuDetailMsg.studentId = item.stuId
            },
            pageChange(){
                this.options.page = 1
                this.initialize()
            },
            initialize() {
                this.searchData.startDate = ''
                this.searchData.endDate = ''
                if (this.searchData.appraiseTime.length > 0) {
                    if (this.searchData.appraiseTime.length == 1) {
                        this.searchData.startDate = this.searchData.appraiseTime[0]
                    } else {
                        this.searchData.startDate = this.searchData.appraiseTime[0]
                        this.searchData.endDate = this.searchData.appraiseTime[1]
                    }
                }
                this.loading = true
                this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
                this.$api.studentRecords.conditionTable(
                    Object.assign({}, this.searchData, this.options)
                ).then(data => {
                    this.loading = false;
                    if (data.data) {
                        this.desserts = data.data;
                        this.totalDesserts = data.total;
                    } else {
                        this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                    }

                })
            },
            changeOptions(option) {
                this.initialize()
            }
        },
        components: {
            scoreDetail,ETDatePicker
        },
    }
</script>
<style></style>
